<template>
  <div
    class="service-category-card"
    :class="{ 'opacity-50': dragging }"
    @click="(e) => onCardClick(e)"
    @dragover.prevent
    @drop.stop.prevent="onDrop">
    <div class="flex justify-between flex-wrap p-8 border-b border-solid border-light hover:bg-light
    cursor-pointer">
        <div class="flex items-start">
            <span
              class="sort-drag-handle text-muted mr-4"
              draggable="true"
              title="Перетащить категорию"
              @click.stop
              @dragstart.stop="onDragStart"
              @dragend.stop="onDragEnd">
              <span v-for="dot in 6" :key="dot" class="sort-drag-dot"></span>
            </span>
            <Attachment class="w-6 h-6 object-center object-contain mr-4"
            v-if="category && category.iconAttach"
            :id="category.iconAttach" />
            <template v-if="!edit">
              <div class="flex flex-col">
                <div class="font-bold text-lg leading-5 text-inverse">{{ category.name }}</div>
                <div class="flex items-center mt-1">
                  <div class="flex items-center mr-6" v-if="hasAbbreviation">
                    <span class="text-brown mr-1">ID:</span>
                    <span class="text-brown font-bold"
                    >{{ category.abbreviation }}</span>
                  </div>
                  <div class="flex items-center mr-6"
                  v-if="hasServicesCount && category.services && category.services.length">
                    <span class="text-brown mr-1">Услуг:</span>
                    <span class="text-brown font-bold">{{ category.services.length }}</span>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="flex flex-row category-card-edit-fields">
                <Input
                  class="mr-8"
                  label="Название категории:"
                  v-model="category.name"
                />
                <Input
                    label="Аббревиатура категории(ID):"
                    v-model="category.abbreviation"
                  />
              </div>
            </template>
        </div>
        <div class="flex items-center">
            <span
              v-if="category.archive"
              class="text-16px leading-18px text-primary font-bold cursor-pointer mr-10"
              @click.stop="onActivateCategory">
                Активировать
            </span>
          <span
            v-else
            class="text-16px leading-18px text-danger font-bold cursor-pointer mr-10"
            @click.stop="onDeactivateCategory">
                Деактивировать
            </span>
<!--            <span-->
<!--                v-if="isEditLayout"-->
<!--                class="text-16px leading-18px text-danger font-bold cursor-pointer mr-10"-->
<!--                @click.stop="(e) => $emit('delete-category', e, category.id)">-->
<!--                Удалить-->
<!--            </span>-->
            <span
                class="text-16px leading-18px text-secondary font-bold cursor-pointer mr-10"
                @click="(e) => onEditClick(e)" v-if="!edit">
                Редактировать
            </span>
            <span
                class="text-16px leading-18px text-secondary font-bold cursor-pointer mr-10"
                @click="(e) => onSaveClick(e)" v-else>
                Сохранить
            </span>
            <span
                class="cursor-pointer flex flex-row items-center"
                @click="(e) => onAddServiceClick(e)"
                v-b-modal="'add'">
                <span class="btn-plus mr-2"></span>
                <b class="text-15px leading-21px text-primary">Добавить услугу в категорию</b>
            </span>
        </div>
    </div>
  </div>
</template>

<script>
import Input from '@/components/Input.vue';
import Attachment from '@/components/global/Attachment.vue';

export default {
  components: {
    Attachment,
    Input,
  },
  data() {
    return {
      edit: false,
    };
  },
  props: {
    category: {
      type: Object,
      default: () => {},
    },
    hasServicesCount: {
      type: Boolean,
      default: true,
    },
    hasAbbreviation: {
      type: Boolean,
      default: true,
    },
    isEditLayout: {
      type: Boolean,
      default: false,
    },
    dragging: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onDragStart(e) {
      if (e.dataTransfer) {
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', String(this.category.id));
      }
      this.$emit('drag-start', this.category.id);
    },
    onDragEnd() {
      this.$emit('drag-end');
    },
    onDrop(e) {
      const rect = e.currentTarget.getBoundingClientRect();
      this.$emit('drop-sort', {
        id: this.category.id,
        after: e.clientY > rect.top + (rect.height / 2),
      });
    },
    onCardClick(e) {
      e.stopPropagation();
      this.$router.push({
        name: 'services.categories.category.services',
        params: {
          id: this.category.id,
        },
      });
    },
    onEditClick(e) {
      e.stopPropagation();
      if (this.$router.currentRoute.name !== 'services.categories.category.about') {
        this.$router.push({
          name: 'services.categories.category.about',
          params: {
            id: this.category.id,
          },
        }).catch(() => {});
      } else {
        this.edit = true;
      }
    },
    onSaveClick(e) {
      e.stopPropagation();
      this.$emit('save-category', this.category.id);
      this.edit = false;
    },
    onAddServiceClick(e) {
      e.stopPropagation();
      this.$emit('add-service', e, this.category.id);
    },
    onActivateCategory() {
      this.$emit('activate', this.category.id);
    },
    onDeactivateCategory() {
      this.$emit('deactivate', this.category.id);
    },
  },
};
</script>

<style scoped>
.sort-drag-handle {
  display: grid;
  grid-template-columns: repeat(2, 3px);
  grid-auto-rows: 3px;
  gap: 3px;
  align-content: center;
  justify-content: center;
  width: 20px;
  min-width: 20px;
  height: 28px;
  cursor: grab;
  user-select: none;
}

.sort-drag-handle:active {
  cursor: grabbing;
}

.sort-drag-dot {
  width: 3px;
  height: 3px;
  border-radius: 9999px;
  background: currentColor;
}
</style>
